import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';

const dataProviderName = 'companies/legalentity';
const wizardName = 'Reload from Zoho';
const wizardAction = 'zohoReload';

const ZohoReload = (params) => {
    const { t } = useTranslation();
    const { close } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);

    const { item, doAction, loadOne, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const modelName = existingModules.modelName;

    useLoadOne({ loadOne, params, reloadCounter });

    const detailConfig = {
        "tabs": [
            {
                "name": "confirm",
                "fieldsets": [
                    {
                        "name": "confirm",
                        "fields": {
                            "info": {
                                "type": "sectionmessageblock",
                                "title": "zoho_reload_title",
                                "paragraph": "zoho_reload_paragraph",
                                "icon": "faArrowsRotate",
                                "className": "col-12 warning",
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    };

    useEffect(() => {
        if (success) {
            close();
        }
    }, [success]);

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data })
            .then((data) => params.handleClose(params.uid, data.item.data))
            .catch(() => console.error('catch handleSave'));
    };

    return (
        <DetailComponent
            disableDetailConfigOverride={true}
            values={{
                "id": item?.data?._id,
            }}
            modelName={modelName}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.reload']}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Reload {{name}} from Zoho', { name: item?.data?.name })}
                />
            }
            {...params}
        />
    );
};

export default ZohoReload;
